import { Refresh } from '@mui/icons-material';
import { Button, Stack, Typography } from '@mui/material';
import { formatDistanceToNow } from 'date-fns';
import { useEffect, useState } from 'react';
import { ONE_MINUTE } from 'shared/constants';

interface GridToolbarRefreshButtonProps {
  refresh(): void;
  updatedAt: Date;
}
function formatTimeAgo(date: Date) {
  return formatDistanceToNow(date, { addSuffix: true });
}

export function GridToolbarRefreshButton({ updatedAt, refresh }: GridToolbarRefreshButtonProps) {
  const [timeAgo, setTimeAgo] = useState(() => formatTimeAgo(updatedAt));

  useEffect(() => {
    setTimeAgo(formatTimeAgo(updatedAt));
    const interval = setInterval(() => {
      setTimeAgo(formatTimeAgo(updatedAt));
    }, ONE_MINUTE);
    return () => {
      clearInterval(interval);
    };
  }, [updatedAt]);

  if (!timeAgo) {
    return null;
  }

  return (
    <Stack direction='row' spacing={1} alignItems='center'>
      <Button onClick={refresh} startIcon={<Refresh />}>
        refresh
      </Button>
      <Typography variant='caption'>Last Refresh: {timeAgo} </Typography>
    </Stack>
  );
}
